import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { lazy } from 'react'

const CareList = lazy(() => import('../pages/CareList'))

const CareRoutes = [
  <RequireAuthentication
    path="/sua-saude/cuidados"
    key="/sua-saude/cuidados"
    exact
    component={CareList}
  />,
]

export default CareRoutes
